import type {Editor, ProjectData} from 'grapesjs';
import type {EmailMakerImmutableStore} from '@EmailMakerReact/email-maker-react.types';
import {EmailMakerMode} from '@EmailMakerReact/email-maker-react.types';
import type {EmailMakerStoreOpts} from '@EmailMakerReact/lib/email-maker-storage-library';
import {
  getCurrentIdEmailTemplate,
  getCurrentMode,
  initEmailMakerStorageState,
  loadEmailTemplateContent,
  storeEmailTemplate,
} from '@EmailMakerReact/lib/email-maker-storage-library';
import type {EmailMakerSavePayloadSources} from '@EmailMakerReact/lib/email-maker-save-payload-library';

export const EMAIL_MAKER_STORAGE_ID = 'remote-storage';

export const EMAIL_MAKER_STORE_OPTS_MODEL_KEY = 'pmwEmailMakerStoreOpts';

export function setEmailMakerStoreOpts(editor: Editor, opts: EmailMakerStoreOpts): void {
  editor.getModel().set(EMAIL_MAKER_STORE_OPTS_MODEL_KEY, opts);
}

export function getEmailMakerStoreOpts(editor: Editor): EmailMakerStoreOpts {
  return (editor.getModel().get(EMAIL_MAKER_STORE_OPTS_MODEL_KEY) as EmailMakerStoreOpts | undefined) ?? {};
}

export function importStorage(editor: Editor, store: EmailMakerImmutableStore, sources: EmailMakerSavePayloadSources): void {
  initEmailMakerStorageState(editor, store);

  editor.StorageManager.add(EMAIL_MAKER_STORAGE_ID, {
    async load(): Promise<ProjectData> {
      const idEmailTemplate = getCurrentIdEmailTemplate(editor);
      if (getCurrentMode(editor) === EmailMakerMode.START || !idEmailTemplate) {
        return {};
      }
      return loadEmailTemplateContent(editor, idEmailTemplate);
    },

    async store(data: ProjectData, opts?: EmailMakerStoreOpts): Promise<ProjectData> {
      return storeEmailTemplate(editor, data, {...getEmailMakerStoreOpts(editor), ...opts}, sources);
    },
  });
}
